import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';

export /**
 *
 */
const Header = () => {
  return (
    <header className="sticky top-0 z-30 border-b border-whisper bg-warm-white/90 backdrop-blur-sm">
      <div className="mx-auto flex h-14 max-w-6xl items-center gap-3 px-4 sm:px-6">
        <Link
          to="/"
          aria-label="Stackly · Dashboard"
          className="flex items-center gap-2.5 text-nav font-bold tracking-tight text-ink"
        >
          <Logo size={26} />
          <span className="font-sans text-[13px] font-[800] tracking-[-0.04em]">
            stackly<span className="text-lav">.</span>
          </span>
        </Link>
      </div>
    </header>
  );
};
